import app from '@devices/settings/device_settings/app.js';
import device_information from '@devices/settings/device_settings/device_information';
import share from '@devices/settings/device_settings/share.js';

export default {
	name: 'ShellyBLUSoil',
	friendly_name: 'BLU Soil',
	category: 'sensor',
	family: 'sensor',
	isPM: false,
	modes: {
		sensor: {
			availableViews: ['basic', 'advanced'],
			channels: 1,
			notifications: ['device_problem', 'lowBattery'],
			charts: true,
			bluetooth_settings: [
				{ title: 'security', component: 'security_ble' },
				{ title: 'zigbee', component: 'zigbee_ble' },
			],
			settings: [
				{
					title: 'sensor_settings',
					components: [{ title: 'temperature_unit', component: 'temperature_unit_g2' }],
				},
				app,
				share,
				{
					title: 'settings',
					components: [
						{ title: 'firmware_version', component: 'firmware_update_ble' },
						{ title: 'factory_reset', component: 'factory_reset_ble' },
					],
				},
				device_information,
			],
		},
	},
};
